import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const MoveUpRight: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M13 5H19V11' }],
    ['path', { d: 'M19 5L5 19' }],
  ],
];

export default MoveUpRight;
